import { Navigate } from "react-router-dom";
import { useAccount } from "./context/AccountContext";

export const MainOnlyRoute = ({ children }) => {
  const { currentAccount, loading } = useAccount();

  if (loading) return <div>Loading...</div>;
  if (!currentAccount) return <Navigate to="/login" />;
  if (currentAccount.type !== "main") return <Navigate to="/dashboard" />;

  return children;
};